import axios from 'axios'
import { apiClient } from './axios.config'

// Detects 503 `{ maintenance: true }` responses (ALB fixed-response during deploys)
// and emits an event so the SPA shows a maintenance screen instead of error toasts.

const MAINTENANCE_EVENT = 'app:maintenance'

const isMaintenanceError = (error: unknown): boolean => {
  const response = (
    error as { response?: { status?: number; data?: { maintenance?: boolean } } }
  )?.response
  return response?.status === 503 && Boolean(response?.data?.maintenance)
}

const emitMaintenance = () =>
  window.dispatchEvent(new CustomEvent(MAINTENANCE_EVENT))

// Subscribe to maintenance-mode activation; returns an unsubscribe fn.
export const onMaintenance = (cb: () => void): (() => void) => {
  window.addEventListener(MAINTENANCE_EVENT, cb)
  return () => window.removeEventListener(MAINTENANCE_EVENT, cb)
}

// Register on BOTH the shared apiClient and the bare axios default — the helpers
// in axios.helpers.ts call axios.* directly — so any 503 maintenance response
// from anywhere flips the app into the maintenance screen. Call once at boot.
export const setupMaintenanceInterceptor = () => {
  const onRejected = (error: unknown) => {
    if (isMaintenanceError(error)) emitMaintenance()
    return Promise.reject(error)
  }
  axios.interceptors.response.use((r) => r, onRejected)
  apiClient.interceptors.response.use((r) => r, onRejected)
}
